var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLagging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "hex-shape",
    fillRule: "evenodd",
    stroke: "none",
    d: "M 50.015167 -0.00016 L 93.030655 24.825249 L 93.030655 74.476044 L 50.015167 99.320999 L 7.018764 74.476044 L 7.018764 24.825249 L 50.015167 -0.00016 Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "hex-icon",
    transform: "translate(25,25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.984375 11 C 9.722656 11.003906 9.476563 11.109375 9.292969 11.292969 L 3.292969 17.292969 C 2.902344 17.683594 2.902344 18.316406 3.292969 18.707031 L 24.292969 39.707031 C 24.683594 40.097656 25.316406 40.097656 25.707031 39.707031 L 46.707031 18.707031 C 47.097656 18.316406 47.097656 17.683594 46.707031 17.292969 L 40.707031 11.292969 C 40.316406 10.902344 39.683594 10.902344 39.292969 11.292969 L 25 25.585938 L 10.707031 11.292969 C 10.515625 11.101563 10.253906 10.996094 9.984375 11 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLagging);
export default __webpack_public_path__ + "static/media/lagging.0d6adba3e8353837d0b450959cfb60de.svg";
export { ForwardRef as ReactComponent };